import { render, staticRenderFns } from "./MobileHeader.vue?vue&type=template&id=2ff3a012&scoped=true&"
import script from "./MobileHeader.vue?vue&type=script&lang=js&"
export * from "./MobileHeader.vue?vue&type=script&lang=js&"
import style0 from "./MobileHeader.vue?vue&type=style&index=0&id=2ff3a012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3a012",
  null
  
)

export default component.exports